import React, {PureComponent} from 'react';


export default class EventDetailScreen extends PureComponent {
  render() {
    let {match} = this.props;
    console.log('match', match)

    return (
        <div>
          <h2>Detail</h2>
        </div>
    )
  }
}
